import { io } from "socket.io-client";
import { SOCKET_URL } from "../constants/env";
class SocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.listeners = new Map();
  }

  connect(serverUrl = SOCKET_URL) {
    if (this.socket && this.isConnected) {
      return this.socket;
    }

    this.socket = io(serverUrl, {
      transports: ["websocket", "polling"],
      autoConnect: true,
    });

    this.setupEventHandlers();
    return this.socket;
  }

  setupEventHandlers() {
    if (!this.socket) return;

    this.socket.on("connect", () => {
      this.isConnected = true;
      this.emit("connectionStatus", { connected: true, id: this.socket.id });
    });

    this.socket.on("disconnect", () => {
      this.isConnected = false;
      this.emit("connectionStatus", { connected: false });
    });

    this.socket.on("connect_error", (error) => {
      this.emit("connectionError", error);
    });

    // Listen for leaderboard changes
    this.socket.on("leaderboardChange", (data) => {
      this.emit("leaderboardChange", data);
    });
  }

  // Generic event emitter for internal listeners
  emit(event, data) {
    const eventListeners = this.listeners.get(event);
    if (eventListeners) {
      eventListeners.forEach((callback) => callback(data));
    }
  }

  // Subscribe to socket events
  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
  }

  // Unsubscribe from socket events
  off(event, callback) {
    const eventListeners = this.listeners.get(event);
    if (eventListeners) {
      const index = eventListeners.indexOf(callback);
      if (index > -1) {
        eventListeners.splice(index, 1);
      }
    }
  }

  // Disconnect socket
  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  // Get connection status
  getConnectionStatus() {
    return {
      connected: this.isConnected,
      id: this.socket?.id || null,
    };
  }
}

// Create singleton instance
const socketService = new SocketService();

export default socketService;
